// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zir714hOKR_0BleJyjXJ {
  display: flex;
  border: 1px solid 2px;
  border-radius: 2px;
  min-height: calc(100vh - 230px);
}
.zir714hOKR_0BleJyjXJ .zRUdLcrbRA0tf7qKe4jt {
  flex: 0 0 260px;
  border-right: 1px solid 2px;
  overflow: hidden;
}
.zir714hOKR_0BleJyjXJ .zRUdLcrbRA0tf7qKe4jt .eRyW_E8Py82hn3n0UybC {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  font-size: 18px;
  line-height: 20px;
  border-bottom: 1px solid 2px;
}
.zir714hOKR_0BleJyjXJ .zRUdLcrbRA0tf7qKe4jt .eRyW_E8Py82hn3n0UybC .anticon {
  font-size: 20px;
}
.zir714hOKR_0BleJyjXJ .zRUdLcrbRA0tf7qKe4jt .TXO4vDLRNWk3pXeLV0gH {
  overflow: auto;
}
.zir714hOKR_0BleJyjXJ .zRUdLcrbRA0tf7qKe4jt .QiIitz1ZpFp57eVaWJ05 {
  display: flex;
  justify-content: space-between;
}
.zir714hOKR_0BleJyjXJ .zRUdLcrbRA0tf7qKe4jt .QiIitz1ZpFp57eVaWJ05 .PITrYIsvCE5z0mNg1_0k {
  display: none;
}
.zir714hOKR_0BleJyjXJ .zRUdLcrbRA0tf7qKe4jt .QiIitz1ZpFp57eVaWJ05 .t2id6kcxjvHpiAkKeJGo {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;
}
.zir714hOKR_0BleJyjXJ .zRUdLcrbRA0tf7qKe4jt .QiIitz1ZpFp57eVaWJ05:hover .PITrYIsvCE5z0mNg1_0k {
  display: block;
}
.zir714hOKR_0BleJyjXJ .J_6ZvNp6OOHEYfMCmJBp {
  flex: auto;
  padding: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Organizations/Item/Setting/Terms/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,+BAAA;AAAF;AAJA;EAOI,eAAA;EACA,2BAAA;EACA,gBAAA;AAAJ;AATA;EAYM,aAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AAAN;AAjBA;EAmBQ,eAAA;AACR;AApBA;EAuBM,cAAA;AAAN;AAvBA;EA2BM,aAAA;EACA,8BAAA;AADN;AA3BA;EA8BQ,aAAA;AAAR;AA9BA;EAkCQ,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADR;AApCA;EA0CQ,cAAA;AAHR;AAvCA;EAgDI,UAAA;EACA,aAAA;AANJ","sourcesContent":["\n.container {\n  display: flex;\n  border: 1px solid 2px;\n  border-radius: 2px;\n  min-height: calc(100vh - 230px);\n\n  .nav {\n    flex: 0 0 260px;\n    border-right: 1px solid 2px;\n    overflow: hidden;\n\n    .navHeader {\n      display: flex;\n      justify-content: space-between;\n      padding: 16px;\n      font-size: 18px;\n      line-height: 20px;\n      border-bottom: 1px solid 2px;\n      :global .anticon {\n        font-size: 20px;\n      }\n    }\n    .navContent {\n      overflow: auto;\n    }\n\n    .menuItem {\n      display: flex;\n      justify-content: space-between;\n      .menuItemAction {\n        display: none;\n      }\n\n      .menuItemName {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-right: 16px;\n      }\n    }\n    .menuItem:hover {\n      .menuItemAction {\n        display: block;\n      }\n    }\n  }\n\n  .content {\n    flex: auto;\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zir714hOKR_0BleJyjXJ`,
	"nav": `zRUdLcrbRA0tf7qKe4jt`,
	"navHeader": `eRyW_E8Py82hn3n0UybC`,
	"navContent": `TXO4vDLRNWk3pXeLV0gH`,
	"menuItem": `QiIitz1ZpFp57eVaWJ05`,
	"menuItemAction": `PITrYIsvCE5z0mNg1_0k`,
	"menuItemName": `t2id6kcxjvHpiAkKeJGo`,
	"content": `J_6ZvNp6OOHEYfMCmJBp`
};
export default ___CSS_LOADER_EXPORT___;
